// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-indicator {
  font-weight: bold;
}
.status-indicator .active-status {
  color: #337ab7;
}
.status-indicator .inactive-status {
  color: #d43f3a;
}
.upload-zone.drop-box {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  position: relative;
}
.upload-zone.drop-box .placeholder-msg {
  display: none;
}
.upload-zone.drop-box .dragover-msg {
  display: none;
}
.upload-zone.drop-box.dragover {
  border-color: #e14f1c;
}
.upload-zone.drop-box.dragover .placeholder-msg {
  display: none;
}
.upload-zone.drop-box.dragover .dragover-msg {
  display: block;
}
.user-profile-photo {
  width: 220px;
  height: 220px;
}
.user-profile-photo img {
  height: 100%;
  width: 100%;
}
.user-profile-photo .placeholder-msg {
  display: none;
}
.user-profile-photo:hover .placeholder-msg {
  display: block;
  position: absolute;
  top: 50%;
  margin-top: -25px;
  background: rgba(255, 255, 255, 0.7);
  left: 0;
}
.profile-page {
  font-size: 14px;
}
#profile-main {
  min-height: 500px;
  position: relative;
}
#profile-main .pm-overview {
  overflow-y: auto;
}
@media (min-width: 1200px) {
  #profile-main .pm-overview {
    width: 300px;
  }
}
@media (min-width: 768px) and (max-width: 1200px) {
  #profile-main .pm-overview {
    width: 250px;
  }
}
@media (min-width: 768px) {
  #profile-main .pm-overview {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background: #f8f8f8;
    border-right: 1px solid #eee;
  }
}
@media (max-width: 767px) {
  #profile-main .pm-overview {
    width: 100%;
    background: #333;
    text-align: center;
  }
}
@media (min-width: 1200px) {
  #profile-main .pm-body {
    padding-left: 300px;
  }
}
@media (min-width: 768px) and (max-width: 1200px) {
  #profile-main .pm-body {
    padding-left: 250px;
  }
}
@media (max-width: 767px) {
  #profile-main .pm-body {
    padding-left: 0;
  }
}
#profile-main .pmo-pic {
  position: relative;
  margin: 20px;
}
@media (min-width: 768px) {
  #profile-main .pmo-pic img {
    width: 100%;
    border-radius: 2px 2px 0 0;
  }
}
@media (max-width: 767px) {
  #profile-main .pmo-pic img {
    width: 180px;
    display: inline-block;
    height: 180px;
    border-radius: 50%;
    border: 4px solid #fff;
    box-shadow: 0 8px 17px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);
  }
}
#profile-main .pmo-pic .pmo-stat {
  border-radius: 0 0 2px 2px;
  color: #fff;
  text-align: center;
  padding: 30px 5px 0;
}
@media (min-width: 768px) {
  #profile-main .pmo-pic .pmo-stat {
    background: #ffc107;
    padding-bottom: 15px;
  }
}
#profile-main .pmo-pic .pmop-edit {
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  background: rgba(0, 0, 0, 0.38);
  text-align: center;
  padding: 10px 10px 11px;
  transition: opacity;
  transition-duration: 250ms;
}
#profile-main .pmo-pic .pmop-edit:hover {
  background: rgba(0, 0, 0, 0.8);
}
#profile-main .pmo-pic .pmop-edit i {
  font-size: 18px;
  vertical-align: middle;
  margin-top: -3px;
}
@media (min-width: 768px) {
  #profile-main .pmo-pic .pmop-edit {
    width: 100%;
    opacity: 0;
    filter: alpha(opacity=0);
  }
  #profile-main .pmo-pic .pmop-edit i {
    margin-right: 4px;
  }
}
#profile-main .pmo-pic:hover .pmop-edit {
  opacity: 1;
  filter: alpha(opacity=100);
}
#profile-main .pmo-pic .pmop-message {
  position: absolute;
  bottom: 27px;
  left: 50%;
  margin-left: -25px;
}
#profile-main .pmo-pic .pmop-message .dropdown-menu {
  padding: 5px 0 55px;
  left: -90px;
  width: 228px;
  height: 150px;
  top: -74px;
  transform-origin: center;
}
#profile-main .pmo-pic .pmop-message .dropdown-menu textarea {
  width: 100%;
  height: 95px;
  border: 0;
  resize: none;
  padding: 10px 19px;
}
#profile-main .pmo-pic .pmop-message .dropdown-menu button {
  position: absolute;
  bottom: 5px;
  left: 93px;
}
#profile-main .pmb-block {
  margin-bottom: 20px;
}
@media (min-width: 1200px) {
  #profile-main .pmb-block {
    padding: 40px 42px 0;
  }
}
@media (max-width: 1199px) {
  #profile-main .pmb-block {
    padding: 30px 20px 0;
  }
}
#profile-main .pmb-block:last-child {
  margin-bottom: 50px;
}
#profile-main .pmb-block .pmbb-header {
  margin-bottom: 25px;
  position: relative;
}
#profile-main .pmb-block .pmbb-header .actions {
  position: absolute;
  top: -2px;
  right: 0;
}
#profile-main .pmb-block .pmbb-header h2 {
  margin: 0;
  font-weight: 100;
  font-size: 20px;
}
#profile-main .pmb-block .pmbb-edit {
  position: relative;
  z-index: 1;
}
#profile-main .pmo-block {
  padding: 25px;
}
#profile-main .pmo-block > h2 {
  font-size: 16px;
  margin: 0 0 15px;
}
#profile-main .pmo-items .pmob-body {
  padding: 0 10px;
}
#profile-main .pmo-items a {
  display: block;
  padding: 4px;
}
#profile-main .pmo-items a img {
  width: 100%;
}
.pmo-contact ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.pmo-contact ul li {
  position: relative;
  padding: 8px 0 8px 35px;
}
.pmo-contact ul li i {
  font-size: 18px;
  vertical-align: top;
  line-height: 100%;
  position: absolute;
  left: 0;
  width: 18px;
  text-align: center;
}
.pmo-map {
  margin: 20px -20px -18px;
  display: block;
}
.pmo-map img {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/membership/styles/user-profile.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,OAAO;AACT;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,yEAAyE;EAC3E;AACF;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE;IACE,WAAW;IACX,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,WAAW;AACb","sourcesContent":[".status-indicator {\n  font-weight: bold;\n}\n.status-indicator .active-status {\n  color: #337ab7;\n}\n.status-indicator .inactive-status {\n  color: #d43f3a;\n}\n.upload-zone.drop-box {\n  text-align: center;\n  font-size: 16px;\n  font-weight: bold;\n  position: relative;\n}\n.upload-zone.drop-box .placeholder-msg {\n  display: none;\n}\n.upload-zone.drop-box .dragover-msg {\n  display: none;\n}\n.upload-zone.drop-box.dragover {\n  border-color: #e14f1c;\n}\n.upload-zone.drop-box.dragover .placeholder-msg {\n  display: none;\n}\n.upload-zone.drop-box.dragover .dragover-msg {\n  display: block;\n}\n.user-profile-photo {\n  width: 220px;\n  height: 220px;\n}\n.user-profile-photo img {\n  height: 100%;\n  width: 100%;\n}\n.user-profile-photo .placeholder-msg {\n  display: none;\n}\n.user-profile-photo:hover .placeholder-msg {\n  display: block;\n  position: absolute;\n  top: 50%;\n  margin-top: -25px;\n  background: rgba(255, 255, 255, 0.7);\n  left: 0;\n}\n.profile-page {\n  font-size: 14px;\n}\n#profile-main {\n  min-height: 500px;\n  position: relative;\n}\n#profile-main .pm-overview {\n  overflow-y: auto;\n}\n@media (min-width: 1200px) {\n  #profile-main .pm-overview {\n    width: 300px;\n  }\n}\n@media (min-width: 768px) and (max-width: 1200px) {\n  #profile-main .pm-overview {\n    width: 250px;\n  }\n}\n@media (min-width: 768px) {\n  #profile-main .pm-overview {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    background: #f8f8f8;\n    border-right: 1px solid #eee;\n  }\n}\n@media (max-width: 767px) {\n  #profile-main .pm-overview {\n    width: 100%;\n    background: #333;\n    text-align: center;\n  }\n}\n@media (min-width: 1200px) {\n  #profile-main .pm-body {\n    padding-left: 300px;\n  }\n}\n@media (min-width: 768px) and (max-width: 1200px) {\n  #profile-main .pm-body {\n    padding-left: 250px;\n  }\n}\n@media (max-width: 767px) {\n  #profile-main .pm-body {\n    padding-left: 0;\n  }\n}\n#profile-main .pmo-pic {\n  position: relative;\n  margin: 20px;\n}\n@media (min-width: 768px) {\n  #profile-main .pmo-pic img {\n    width: 100%;\n    border-radius: 2px 2px 0 0;\n  }\n}\n@media (max-width: 767px) {\n  #profile-main .pmo-pic img {\n    width: 180px;\n    display: inline-block;\n    height: 180px;\n    border-radius: 50%;\n    border: 4px solid #fff;\n    box-shadow: 0 8px 17px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19);\n  }\n}\n#profile-main .pmo-pic .pmo-stat {\n  border-radius: 0 0 2px 2px;\n  color: #fff;\n  text-align: center;\n  padding: 30px 5px 0;\n}\n@media (min-width: 768px) {\n  #profile-main .pmo-pic .pmo-stat {\n    background: #ffc107;\n    padding-bottom: 15px;\n  }\n}\n#profile-main .pmo-pic .pmop-edit {\n  position: absolute;\n  top: 0;\n  left: 0;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.38);\n  text-align: center;\n  padding: 10px 10px 11px;\n  transition: opacity;\n  transition-duration: 250ms;\n}\n#profile-main .pmo-pic .pmop-edit:hover {\n  background: rgba(0, 0, 0, 0.8);\n}\n#profile-main .pmo-pic .pmop-edit i {\n  font-size: 18px;\n  vertical-align: middle;\n  margin-top: -3px;\n}\n@media (min-width: 768px) {\n  #profile-main .pmo-pic .pmop-edit {\n    width: 100%;\n    opacity: 0;\n    filter: alpha(opacity=0);\n  }\n  #profile-main .pmo-pic .pmop-edit i {\n    margin-right: 4px;\n  }\n}\n#profile-main .pmo-pic:hover .pmop-edit {\n  opacity: 1;\n  filter: alpha(opacity=100);\n}\n#profile-main .pmo-pic .pmop-message {\n  position: absolute;\n  bottom: 27px;\n  left: 50%;\n  margin-left: -25px;\n}\n#profile-main .pmo-pic .pmop-message .dropdown-menu {\n  padding: 5px 0 55px;\n  left: -90px;\n  width: 228px;\n  height: 150px;\n  top: -74px;\n  transform-origin: center;\n}\n#profile-main .pmo-pic .pmop-message .dropdown-menu textarea {\n  width: 100%;\n  height: 95px;\n  border: 0;\n  resize: none;\n  padding: 10px 19px;\n}\n#profile-main .pmo-pic .pmop-message .dropdown-menu button {\n  position: absolute;\n  bottom: 5px;\n  left: 93px;\n}\n#profile-main .pmb-block {\n  margin-bottom: 20px;\n}\n@media (min-width: 1200px) {\n  #profile-main .pmb-block {\n    padding: 40px 42px 0;\n  }\n}\n@media (max-width: 1199px) {\n  #profile-main .pmb-block {\n    padding: 30px 20px 0;\n  }\n}\n#profile-main .pmb-block:last-child {\n  margin-bottom: 50px;\n}\n#profile-main .pmb-block .pmbb-header {\n  margin-bottom: 25px;\n  position: relative;\n}\n#profile-main .pmb-block .pmbb-header .actions {\n  position: absolute;\n  top: -2px;\n  right: 0;\n}\n#profile-main .pmb-block .pmbb-header h2 {\n  margin: 0;\n  font-weight: 100;\n  font-size: 20px;\n}\n#profile-main .pmb-block .pmbb-edit {\n  position: relative;\n  z-index: 1;\n}\n#profile-main .pmo-block {\n  padding: 25px;\n}\n#profile-main .pmo-block > h2 {\n  font-size: 16px;\n  margin: 0 0 15px;\n}\n#profile-main .pmo-items .pmob-body {\n  padding: 0 10px;\n}\n#profile-main .pmo-items a {\n  display: block;\n  padding: 4px;\n}\n#profile-main .pmo-items a img {\n  width: 100%;\n}\n.pmo-contact ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.pmo-contact ul li {\n  position: relative;\n  padding: 8px 0 8px 35px;\n}\n.pmo-contact ul li i {\n  font-size: 18px;\n  vertical-align: top;\n  line-height: 100%;\n  position: absolute;\n  left: 0;\n  width: 18px;\n  text-align: center;\n}\n.pmo-map {\n  margin: 20px -20px -18px;\n  display: block;\n}\n.pmo-map img {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
